import { IFrameGameURLEnum } from '@kira-dancer/nuxt-common/enums/game'
import { RoutesEnum, AuthTabEnum } from '~/enums'
import { LOGIN_REQUIRED_REDIRECT } from '~/resources/common'
import type { LoginURL } from '~/resources/common'

export default defineNuxtRouteMiddleware((to) => {
  const { isLogged } = useUser()
  const { openAuthModal } = useAuth()
  const authStore = useAuthStore()
  const protectedRoutes = [
    IFrameGameURLEnum.ESPORTS,
    IFrameGameURLEnum.VIRTUAL_SPORTS,
    RoutesEnum.FavoriteGames,
  ]

  const isSlugPage = !!to.params.slug
  let shouldLogin = !isLogged.value

  if (isSlugPage) {
    shouldLogin =
      protectedRoutes.includes(to.path as IFrameGameURLEnum) && !isLogged.value
  }

  if (shouldLogin && LOGIN_REQUIRED_REDIRECT.includes(to.path as LoginURL)) {
    setTimeout(() => {
      authStore.setSelectedAuthTab(AuthTabEnum.Login)
      openAuthModal()
    }, 1000)

    // return RoutesEnum.Home
  }
})
